import axios from "axios";

export const getBasePath = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL.replace(/\/+$/, "");
    return configuredBaseUrl === "/" ? "" : configuredBaseUrl;
  }

  const { hostname, port } = window.location;

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    (port === "3000" && hostname !== "vishwaram.com" && hostname !== "www.vishwaram.com")
  ) {
    return `http://${hostname}:8080`;
  }

  return "";
};

export const getStackoverflowUser = (userId) => {
  return axios
    .get(`https://api.stackexchange.com/users/${userId}?site=stackoverflow`)
    .catch((error) => {
      console.error(error);
    });
};

export const getYoutubeVideos = () => {
  const authHeader = getAuthHeader();
  return axios.get(`${getBasePath()}/api/google/youtubeVideos`, {
    auth: authHeader,
  });
};

const getAuthHeader = () => {
  return {
    username: process.env.REACT_APP_SERVER_USERNAME,
    password: process.env.REACT_APP_SERVER_PASSWORD,
  };
};

export const getGDriveFiles = () => {
  const driveUrl = `${getBasePath()}/api/google/religiousPics`;
  const authHeader = getAuthHeader();
  return axios.get(driveUrl, {
    auth: authHeader,
  });
};

export const getGDriveFile = (id) => {
  const driveUrl = `${getBasePath()}/api/google/file?id=${id}`;
  const authHeader = getAuthHeader();
  return axios.get(driveUrl, {
    auth: authHeader,
    responseType: "arraybuffer",
  });
};

export const getMerchCatalog = () => {
  const authHeader = getAuthHeader();
  return axios.get(`${getBasePath()}/api/printify/merch`, {
    auth: authHeader,
  });
};

export const getBirthChartNaming = (payload) => {
  const authHeader = getAuthHeader();
  return axios.post(`${getBasePath()}/api/v1/panchang/naming/letters/by-city`, payload, {
    auth: authHeader,
  });
};

export const getBirthChartCities = (country = "") => {
  const authHeader = getAuthHeader();
  return axios.get(`${getBasePath()}/api/v1/panchang/cities`, {
    auth: authHeader,
    params: { country },
  });
};

export const submitPanchangIntake = (payload) => {
  return axios.post(`${getBasePath()}/api/v1/panchang/intake`, payload);
};

export const getPanchangIntakeQueue = (username, password) => {
  return axios.get(`${getBasePath()}/api/admin/panchang/intake`, {
    auth: {
      username,
      password,
    },
  });
};

export const searchSymbol = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=SYMBOL_SEARCH&keywords=${ticker}&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const getIntradayData = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=TIME_SERIES_INTRADAY&symbol=${ticker}&interval=5min&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const getDailyHistory = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=TIME_SERIES_DAILY&symbol=${ticker}&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const getSymbolHistory = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=TIME_SERIES_WEEKLY&symbol=${ticker}&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const getCompanyOverview = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=OVERVIEW&symbol=${ticker}&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const getSymbolQuote = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_STOCK_API}/query?function=GLOBAL_QUOTE&symbol=${ticker}&apikey=${process.env.REACT_APP_STOCK_API_KEY}`;
  return axios.get(apiUrl);
};

export const searchInstrument = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_FINNHUB_API}/search?q=${ticker}&token=${process.env.REACT_APP_FINNHUB_API_KEY}`;
  return axios.get(apiUrl);
};

export const getInstrumentQuote = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_FINNHUB_API}/quote?symbol=${ticker}&token=${process.env.REACT_APP_FINNHUB_API_KEY}`;
  return axios.get(apiUrl);
};

export const getInstrumentMetrics = (ticker) => {
  const apiUrl = `${process.env.REACT_APP_FINNHUB_API}/stock/metric?symbol=${ticker}&metric=all&token=${process.env.REACT_APP_FINNHUB_API_KEY}`;
  return axios.get(apiUrl);
};

export const searchFinanceInstrument = (query) => {
  const apiUrl = `${getBasePath()}/api/finance/search?q=${encodeURIComponent(
    query
  )}`;
  return axios.get(apiUrl);
};

export const getFinanceChart = (symbol, range = "1mo", interval = "1d") => {
  const apiUrl = `${getBasePath()}/api/finance/chart?symbol=${encodeURIComponent(
    symbol
  )}&range=${encodeURIComponent(range)}&interval=${encodeURIComponent(interval)}`;
  return axios.get(apiUrl);
};

const TWELVE_DATA_BASE = "https://api.twelvedata.com";
const TWELVE_DATA_KEY = "demo";

export const searchTwelveDataSymbol = (query) => {
  const apiUrl = `${TWELVE_DATA_BASE}/symbol_search?symbol=${encodeURIComponent(
    query
  )}&apikey=${TWELVE_DATA_KEY}`;
  return axios.get(apiUrl);
};

export const getTwelveDataQuote = (symbol) => {
  const apiUrl = `${TWELVE_DATA_BASE}/quote?symbol=${encodeURIComponent(
    symbol
  )}&apikey=${TWELVE_DATA_KEY}`;
  return axios.get(apiUrl);
};

export const getTwelveDataTimeSeries = (symbol, interval = "1day", outputsize = 30) => {
  const apiUrl = `${TWELVE_DATA_BASE}/time_series?symbol=${encodeURIComponent(
    symbol
  )}&interval=${encodeURIComponent(interval)}&outputsize=${outputsize}&apikey=${TWELVE_DATA_KEY}`;
  return axios.get(apiUrl);
};
